import { LOCATION_CHANGE } from 'react-router-redux';

import { SearchActions } from '../../constants';
import * as SearchWorkers from '../workers';

export default [
  {
    actionType: SearchActions.FULL_SEARCH,
    handler: SearchWorkers.getSearchResults,
    concur: 'takeEvery',
  },
  {
    actionType: LOCATION_CHANGE,
    handler: SearchWorkers.closeSearch,
    concur: 'takeEvery',
  },
];
